<template>
    <v-card class="border-thin rounded-xl clientCard" elevation="4">
        <div class="d-flex flex-column">

            <div class="d-flex justify-space-between">

                <!-- Client data -->
                <div class="d-flex pa-4">

                    <!-- Logo -->
                    <v-avatar size="130" rounded="0">
                        <v-img alt="ClientLogo" class="projectImage" :src="getLogo()" :cover="false"></v-img>
                    </v-avatar>

                    <div class="d-flex">
                        <div class="d-flex flex-column">

                            <div class="d-flex">

                                <!-- Project name -->
                                <v-card-title class="font-weight-bold text-h5 pb-0 text-indigo-darken-4">{{ projectName
                                    }}</v-card-title>

                                <!-- Zerotier status -->
                                <v-tooltip>
                                    <template v-slot:activator="{ props }">
                                        <v-icon v-bind="props" icon="fa-solid fa-circle" class="zerotier-active"
                                            size="x-small" :color="getIconColor()"></v-icon>
                                    </template>
                                    <div v-for="(server, index) in project.servers" :key="index">
                                        {{ server.name.replace("rosepetal-", "") }} : {{ server.isOnline ? 'online' : 'offline' }} (last connection: {{ server.lastConnection }})
                            
                                    </div>
                                </v-tooltip>

                            </div>

                            <!-- Project name + Tier-->
                            <v-card-subtitle class="text-subtitle-1 pt-0">{{ project.firebaseConfig.projectId}}</v-card-subtitle>
                            <!-- TODO: TIER SUBTITLE ONCE BILLING IS IMPLEMENTED-->
                            <!-- <v-card-subtitle class="text-subtitle-1">Tier 1</v-card-subtitle> -->
                        </div>

                    </div>

                </div>

                <!-- Actions -->
                <div class="d-flex flex-column ga-2 pr-6 pt-4">

                    <v-btn icon="fa-solid fa-eye" size="small" color="indigo-darken-4" variant="text" density="compact"
                        @click="router.push({ name: 'client', params: { id: props.project.id}, })" />

                    <v-btn icon="fa-solid fa-pen" size="small" color="indigo-darken-4" variant="text"
                        density="compact" @click="router.push({ name: 'client',  params: { id: props.project.id }, state: {isPageEditable: true}})" />

                    <v-btn icon="fa-solid fa-trash-can" size="small" color="indigo-darken-4" variant="text"
                        density="compact" @click="deleteProjectDialog = true" />

                    <!-- Delete client popup -->
                    <v-dialog v-model="deleteProjectDialog" max-width="500" class="h-auto ">
                        <v-card class="border-thin rounded-xl">
                            <v-card-title class="text-center font-weight-bold text-h4 pb-0 pt-4">
                                Delete client?
                            </v-card-title>
                            <v-card-text class="text-center">Are you sure you want to delete the client from the firestore? This action is not reversible.</v-card-text>
                            <div class="d-flex justify-space-around pa-4">
                                <v-btn color="red" size="large" @click="confirmDeleteProject">Delete</v-btn>
                                <v-btn size="large" @click="deleteProjectDialog = false">Cancel</v-btn>
                            </div>
                        </v-card>
                    </v-dialog>

                </div>

            </div>

            <!-- Fechas proyecto cliente -->
            <div class="d-flex justify-end pt-2 pr-4 pb-1">
                <div class="text-subtitle-2 text-right text-indigo-darken-4 font-weight-bold">CREATED ON </div>
                <div class="text-subtitle-2 text-right text-gray-500 pr-4">&nbsp;{{formatText(props.project?.metadata?.createdAt)}}</div>
                <div class="text-subtitle-2 text-right text-indigo-darken-4 font-weight-bold">UPDATED ON</div>
                <div class="text-subtitle-2 text-right text-gray-500">&nbsp;{{formatText(props.project?.metadata?.updatedAt)}}</div>
            </div>

        </div>
    </v-card>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

function formatText(value) {
    if (typeof value === "object" && value.seconds) {
        return value.toDate().toLocaleString().split(',')[0];
    }
    return value;
}

const router = useRouter();

const deleteProjectDialog  = ref(false);
const projectName          = (props.project.id).replace("dep-", "");

const props = defineProps({
    project: Object,
    deleteProject: Function
});

function getIconColor() {
    return props.project.isProjectOnline ? 'green' : 'red'
}

function confirmDeleteProject() {
    props.deleteProject(props.project.id);
    deleteProjectDialog.value = false;
}

function getLogo() {
    if (!props.project.metadata?.logo) return require(`@/assets/logos/rp_isotype_white.png`);
    return `data:image/png;base64, ${props.project.metadata.logo}`;
}

</script>

<style scoped>
.clientCard {
    min-width: 450px;
}

.zerotier-active {
    padding-top: 28px;
    margin-left: -10px;
}
</style>